define('lq/richText',[
    'jquery',
    'underscore',
    'lq/domainDefinitions',
    'lq/style',
    'lq/eventSource'
], function ($, _, DomainDefinitions, Style, EventSource) {

        var richTextStringPrefix = 'RICHTEXT:';

        var isRichTextString = function (value) {
            if (value === undefined || value === null || !value.substring || value.length <= richTextStringPrefix.length) return false;
            return value.substring(0, richTextStringPrefix.length) == richTextStringPrefix;
        };

        var modelToRichTextString = function (richTextModel) {
            return richTextStringPrefix + JSON.stringify(richTextModel);
        };

        var modelFromRichTextString = function (richTextString) {
            return JSON.parse(richTextString.substring(richTextStringPrefix.length));
        };

        var convertToHtml = function (value) {
            if (typeof value !== 'string') return value;

            // http://stackoverflow.com/questions/5007574/rendering-plaintext-as-html-maintaining-whitespace-without-pre
            // http://stackoverflow.com/questions/1219860/html-encoding-in-javascript-jquery
            return value
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\t/g, '    ')
                .replace(/  /g, '&nbsp; ')
                .replace(/  /g, ' &nbsp;')
                .replace(/\r\n|\n|\r/g, '<br />');
        };

        var RichTextEditorSection = function (richTextEditor, content) {
            var self = this;
            self.richTextEditor = richTextEditor;

            if (content) {
                self.data = {
                    styles: content.styleId,
                    text: content.text
                };
            } else {
                self.data = {
                    styles: null,
                    text: ''
                };
            }

            self.$element = self.createRichTextEditorSection();
            self.$viewer = self.createViewer(richTextEditor);
        };

        RichTextEditorSection.prototype.createRichTextEditorSection = function () {
            return $('<div />')
                .addClass('richTextEditorSection');
        };

        RichTextEditorSection.prototype.createViewer = function () {
            var self = this;

            var $viewer = $('<div />')
                .addClass('richTextEditorSectionViewer')
                .appendTo(self.$element);

            if (this.richTextEditor.editable) {
                $viewer
                    .on('click', function () {
                        self.openEditor();
                    });
            }

            if (self.data.text !== '') {
                $viewer.html(self.data.text);
                Style.renderStyles(self, null, $viewer);
            } else if (this.richTextEditor.editable) {
                this.setPlaceholder($viewer);
            }

            return $viewer;
        };

        RichTextEditorSection.prototype.openEditor = function () {
            var self = this;

            self.$viewer.hide();

            if (self.$editor) {
                self.$editor.show();
                self.$editor.trigger('focus');
                return;
            }

            self.$editor = $('<div />')
                .addClass('richTextEditorSectionEditor')
                .appendTo(self.$element);

            var $toolbar = this.buildToolbar()
                .addClass('richTextEditorToolbar')
                .appendTo(self.$editor);
            
            var $textAreaDiv = $('<div />')
                .addClass('richTextEditorTextAreaDiv')
                .appendTo(self.$editor);

            var $textArea = $('<textarea/>')
                .val(self.data.text)
                .addClass('richTextEditingTextArea')
                .css({
                    width: '100%',
                    'max-width': '100%'
                })
                .appendTo($textAreaDiv);

            if (!self.richTextEditor.simpleRichTextEditor) {
                $textAreaDiv
                    .addClass('richTextEditorTextAreaDivFullMode');

                $toolbar
                    .addClass('richTextEditorToolbarFullMode');

                this.buildStylesBar()
                    .addClass('richTextEditorStylesBar')
                    .appendTo(self.$editor);

                this.buildSectionOperationsBar()
                    .addClass('richTextEditorSectionOperationsBar')
                    .appendTo(self.$editor);
            }

            // Only load the Wysihtml5 files when we actually need the editor. Rich text is used by both 
            // TextArea and DynamicText which both are used extensively, but the editor functionality 
            // is only used once in a while.
            // Instead of fixing this here we should actually just get rid of this rich text editor.
            require([
                'Wysihtml5/wysihtml5-0.4.0pre',
                'Wysihtml5/parser_rules/licquid',
                'Wysihtml5/jquery.wysihtml5_size_matters'
            ], function () {
                    var editor = new wysihtml5.Editor($textArea[0], {
                        toolbar: $toolbar.get(0),
                        parserRules: wysihtml5ParserRules,
                        stylesheets: require.toUrl('../Lq/richTextEditor.css')
                    });

                    editor.observe('load', function () {
                        $textArea.data('editor', editor);
                        $(editor.composer.iframe).wysihtml5_size_matters();
                        editor.focus();
                    });

                    editor.on('change', function () {
                        self.updateViewerFromEditor(editor);
                    });

                    editor.on('aftercommand:composer', function () {
                        self.updateViewerFromEditor(editor);
                    });

                    editor.on('blur', function () {
                        self.richTextEditor.triggerFocusLost();
                    });
                });            
        };

        RichTextEditorSection.prototype.buildToolbar = function () {
            var $toolbar = $('<div />');

            $('<button />')
                .attr('data-wysihtml5-command', 'bold')
                .addClass('smallbutton')
                .css({ 'font-weight': 'bold' })
                .text('b')
                .appendTo($toolbar);

            $('<button />')
                .attr('data-wysihtml5-command', 'italic')
                .addClass('smallbutton')
                .css({ 'font-style': 'italic' })
                .text('i')
                .appendTo($toolbar);

            $('<button />')
                .attr('data-wysihtml5-command', 'underline')
                .addClass('smallbutton')
                .css({ 'text-decoration': 'underline' })
                .text('u')
                .appendTo($toolbar);

            $('<button />')
                .attr('data-wysihtml5-command', 'insertUnorderedList')
                .addClass('smallbutton')
                .text('•')
                .appendTo($toolbar);

            $('<button />')
                .attr('data-wysihtml5-command', 'insertOrderedList')
                .addClass('smallbutton')
                .text('1.')
                .appendTo($toolbar);

            $('<button class="smallbutton">url</button>')
                .attr('data-wysihtml5-command', 'createLink')
                .appendTo($toolbar);

            $('<div>')
                .hide()
                .attr('data-wysihtml5-dialog', 'createLink')
                .append($('<input type="text" value="http://">')
                    .attr('data-wysihtml5-dialog-field', 'href'))
                .append($('<button class="smallbutton">ok</button>')
                    .attr('data-wysihtml5-dialog-action', 'save'))
                .appendTo($toolbar);

            return $toolbar;
        };

        RichTextEditorSection.prototype.buildStylesBar = function () {
            var self = this;
            var $styleDiv = $('<div />');

            self.$styleSelect = $('<select />')
                .width(150)
                .on('change', function () {
                    Style.removeStyleClass(self, null, self.$viewer);
                    self.data.styles = self.$styleSelect.val();
                    Style.renderStyles(self, null, self.$viewer);
                })
                .appendTo($styleDiv)
                .append($('<option />', { value: null, text: '...' }));

            _.chain(DomainDefinitions.styles.genericStyles)
             .sortBy(function (style) { return (style.name || '').toLowerCase(); })
             .filter(function (style) { return style.normal && style.normal.runtime; })
             .forEach(function (style) {
                 $('<option />', {
                     value: style.id,
                     text: style.name
                 })
                 .appendTo(self.$styleSelect);
             });

            self.$styleSelect.val(self.data.styles);

            $('<button />')
                .addClass('smallbutton')
                .text('x')
                .on('click', function () {
                    self.richTextEditor.removeSection(self);
                })
                .appendTo($styleDiv);

            return $styleDiv;
        };
        
        RichTextEditorSection.prototype.buildSectionOperationsBar = function () {
            var self = this;
            var $sectionOperations = $('<div />')
                .width(25);

            $('<button />')
                .addClass('smallbutton')
                .text('+')
                .on('click', function () {
                    self.richTextEditor.addSectionBefore(self);
                })
                .appendTo($sectionOperations);

            $('<button />')
                .addClass('smallbutton')
                .html('&#x25B2;')
                .on('click', function () {
                    if (self.richTextEditor.moveSectionUp(self)) {
                        self.reopenEditor();
                    }
                })
                .appendTo($sectionOperations);

            $('<button />')
                .addClass('smallbutton')
                .html('&#x25BC;')
                .on('click', function () {
                    if (self.richTextEditor.moveSectionDown(self)) {
                        self.reopenEditor();
                    }
                })
                .appendTo($sectionOperations);

            $('<button />')
                .addClass('smallbutton')
                .text('+')
                .on('click', function () {
                    self.richTextEditor.addSectionAfter(self);
                })
                .appendTo($sectionOperations);

            return $sectionOperations;
        };

        RichTextEditorSection.prototype.updateViewerFromEditor = function (editor) {
            var newValue = editor.getValue(true);
            var oldValue = this.$viewer.html();
            
            if (newValue !== oldValue) {
                this.$viewer.empty();
                this.$viewer.html(newValue);
            }

            if (newValue === '') {
                this.setPlaceholder(this.$viewer);
            }

            this.data.text = newValue;
        };

        RichTextEditorSection.prototype.setPlaceholder = function ($viewer) {
            $viewer.empty();

            var placeHolder = $('<span></span>')
                .addClass('richTextEditorPlaceholder')
                .text(this.richTextEditor.placeholder || 'Click here to start editing the content');
            $viewer.append(placeHolder);
        };

        // wysihtml5 editor doesn't work after moving the div, so we remove it and reinitiate it
        RichTextEditorSection.prototype.reopenEditor = function () {
            var self = this;
            self.$editor.remove();
            self.$editor = null;

            setTimeout(function () {
                self.openEditor();
            });
        };

        RichTextEditorSection.prototype.closeEditor = function () {
            if (this.$editor) {
                this.$editor.hide();
                this.$viewer.show();
                this.$element.css({ height: 'auto' });
            }
        };

        RichTextEditorSection.prototype.toModel = function () {
            return {
                text: this.data.text,
                styleId: this.data.styles
            };
        };

        var RichTextEditor = function (config) {
            var self = this;

            self.$element = config.parentElement;
            self.placeholder = config.placeholder;
            self.simpleRichTextEditor = config.simpleRichTextEditor;
            self.sections = config.sections || [];
            self.editable = config.editable;
            EventSource.call(this, 'FocusLost');

            self.$richTextEditor = $('<div />')
                .addClass('richTextEditor')
                .appendTo(self.$element);

            if (config.editable) {
                if (self.simpleRichTextEditor) {
                    var defaultSection = new RichTextEditorSection(self);
                    self.sections.push(defaultSection);
                    self.$richTextEditor.append(defaultSection.$element);
                }

                if (!self.simpleRichTextEditor) {
                    self.$richTextEditor
                        .addClass('richTextEditorFullMode');

                    self.$richTextEditorBottomActions = $('<div />')
                        .addClass('richTextEditorBottomActions')
                        .appendTo(self.$element);

                    self.$richTextEditorLeftActions = $('<div />')
                        .addClass('richTextEditorLeftActions')
                        .appendTo(self.$richTextEditorBottomActions);

                    $('<button />')
                        .text('+')
                        .on('click', function() {
                            var newSection = new RichTextEditorSection(self);
                            self.sections.push(newSection);
                            self.$richTextEditor.append(newSection.$element);
                        })
                        .appendTo(self.$richTextEditorLeftActions);
                }

                $(document).on('click', function (e) {
                    var clickedSection = $(e.target).closest('.richTextEditorSection');
                    var nonSelectedSections = $.grep(self.sections, function (a) {
                        return a.$element[0] !== clickedSection[0];
                    });
                    $.each(nonSelectedSections, function (key, section) {
                        section.closeEditor();
                    });
                });
            }
        };

        RichTextEditor.prototype.addSectionBefore = function (section) {
            var index = this.sections.indexOf(section);
            var newSection = new RichTextEditorSection(this);
            this.sections.splice(index, 0, newSection);

            section.$element.before(newSection.$element);
        };

        RichTextEditor.prototype.addSectionAfter = function (section) {
            var index = this.sections.indexOf(section) + 1;
            var newSection = new RichTextEditorSection(this);
            this.sections.splice(index, 0, newSection);

            section.$element.after(newSection.$element);
        };

        RichTextEditor.prototype.removeSection = function (section) {
            var index = this.sections.indexOf(section);
            this.sections.splice(index, 1);

            section.$element.remove();
        };

        RichTextEditor.prototype.moveSectionUp = function (section) {
            var index = this.sections.indexOf(section);

            if (index === 0) {
                return false;
            }

            this.sections.splice(index, 1);
            this.sections.splice(index - 1, 0, section);

            this.sections[index].$element.before(section.$element);

            return true;
        };

        RichTextEditor.prototype.moveSectionDown = function (section) {
            var index = this.sections.indexOf(section);

            if (index === this.sections.length) {
                return false;
            }

            this.sections.splice(index, 1);
            this.sections.splice(index + 1, 0, section);

            this.sections[index].$element.after(section.$element);

            return true;
        };

        RichTextEditor.prototype.clearSections = function () {
            _.forEach(this.sections, function (section) {
                section.$element.remove();
            });
            this.sections = [];
        };

        RichTextEditor.prototype.fromModel = function (model) {
            var self = this;

            self.clearSections();

            if (model.sections) {
                _.forEach(model.sections, function (sectionModel) {
                    var section = new RichTextEditorSection(self, sectionModel);
                    self.sections.push(section);
                    self.$richTextEditor.append(section.$element);
                });
            }
        };

        RichTextEditor.prototype.fromString = function (content) {
            if (isRichTextString(content)) {
                this.fromModel(modelFromRichTextString(content));
            } else {
                this.clearSections();

                var section = new RichTextEditorSection(this, {
                    text: convertToHtml(content) || ''
                });
                this.sections.push(section);
                this.$richTextEditor.append(section.$element);
            }
        };


        RichTextEditor.prototype.toModel = function () {
            return {
                sections: $.map(this.sections, function (section) {
                    return section.toModel();
                })
            };
        };

        RichTextEditor.prototype.toString = function () {
            var model = this.toModel();
            return modelToRichTextString(model);
        };

        RichTextEditor.prototype.close = function () {
            this.$richTextEditor.remove();
            this.$richTextEditorBottomActions.remove();
        };

        return {
            RichTextEditor: RichTextEditor,
            isRichTextString: isRichTextString,
            modelFromRichTextString: modelFromRichTextString,
            modelToRichTextString: modelToRichTextString
        };
    });
